<h2 mat-dialog-title>
  <mat-icon svgIcon="sell_outlined"></mat-icon>
  Rediger prispolitik for alle ladepunkter
</h2>
<form [formGroup]="formGroup" (ngSubmit)="savePricePolicy()">
  @let locationName = chargingStationLocationDetails?.chargingStationLocationName ?? '';
  <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
  <mat-dialog-content>
    <div class="form-row">
      <ok-feedback-info>
        @if (connectorCount > 0) {
          <p>
            {{ connectorCount }} ladepunkt(er) under lokationen
            <strong>{{ locationName }}</strong>
            vil blive opdateret til den valgte prispolitik
          </p>
        }
        @if (connectorCount === 0) {
          <p>
            Der er ingen ladepunkter under lokationen
            <strong>{{ locationName }}</strong>
          </p>
        }
      </ok-feedback-info>
    </div>

    @if (connectorCount > 0) {
      @if (!canHaveDynamicPricePolicy) {
        <div class="form-row">
          <ok-feedback-info role="status">{{ dynamicPricePolicyWarning }}</ok-feedback-info>
        </div>
      }
      <div class="form-row">
        <adm-adm-price-policy-typeahead
          [initialPricePolicyId]="initialPricePolicyId?.toString() ?? null"
          [organizationId]="organizationId"
          [includeGlobal]="true"
          [alwaysIncludeDynamic]="canHaveDynamicPricePolicy"
          [type]="pricePolicyType"
          (itemSelected)="onPricePolicySelected($event)" />
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      class="actions__button"
      type="submit"
      [disabled]="formGroup.invalid || loading || connectorCount === 0"
      [class.spinner]="loading"
      mat-flat-button
      color="primary">
      Gem
    </button>
  </mat-dialog-actions>
</form>
